export default function MonthTabs({ months, handleTabSwitch, activeMonth }) {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        height: "50px",
        padding: "6px",
        backgroundColor: "rgba(73, 73, 73, 0.66)",
        borderRadius: "100px",
        overflowX: "auto",
        maxWidth: "100%",
      }}
    >
      <style>{`
        .month-tab-btn {
          flex-shrink: 0;
          height: 100%;
          padding: 8px 16px;
          border: none;
          border-radius: 999px;
          background: transparent;
          color: #aeaeae;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.15s, color 0.15s;
        }
        .month-tab-btn.active {
          background: #aeaeae;
          color: #1f1f1f;
        }
        .month-tab-btn:hover:not(.active) {
          color: #d0d0d0;
        }
      `}</style>
      {months.map((month) => (
        <button
          key={month}
          className={`month-tab-btn${activeMonth === month ? " active" : ""}`}
          onClick={() => handleTabSwitch(month)}
        >
          {month}
        </button>
      ))}
    </div>
  );
}
